import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import React from "react";

export default function BasicToolForm({ onClose, nodeForm, onSubmit, onBack }) {
  const { register } = nodeForm.form;
  return (
    <>
      <form onSubmit={(e) => { e.preventDefault(); nodeForm.form.handleSubmit(onSubmit)(); }}>
        <ModalBody>
          <FormControl>
            <FormLabel>Name</FormLabel>
            <Input {...register("data.name")} />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button mr={3} onClick={onBack}>
            Back
          </Button>
          <Button type="button" onClick={() => nodeForm.form.handleSubmit(onSubmit)()} colorScheme="yellow">
            Next
          </Button>
        </ModalFooter>
      </form>
    </>
  );
}
